module.exports = __webpack_public_path__ + "img/feiyuhan.975d1601.jpg";